(ns common.attribute
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.schema.entity-type-names :as entity-type-names]
   [common.schema.registry :as registry]
   [common.util :as cu]))

(defn- reverse-ref-label
  "A reverse ref such as `:investor/_legal-entity` is not a field of the entity
   it appears on: on a company it is every investor whose
   `:investor/legal-entity` points at that company. No field schema declares it
   under any tenant, so `registry/get-field-schema` returns nil and the label
   used to fall through to the attribute keyword itself. A breadcrumb built from
   the forward attribute would be worse than nothing - on a company row
   \"Investor - Legal entity\" reads as the investor's own legal-entity field.
   Name the collection instead: the source entity type, plural."
  [attribute]
  (when-let [forward (cu/forward-attribute attribute)]
    (entity-type-names/get-plural (keyword "entity.type" (namespace forward))
                                  :en)))

;; k is an attribute-keyword or a list/vector of
;;  kws (e.g. [:oppo/target-asset :company/company-owner :account/email]).
;;  The label of latter is breadcrumbs with dashes (e.g. "Company - Owner - Email")
(defn attribute-label
  [tenant-schema k]
  (cond
    (keyword? k)
    (or (reverse-ref-label k)
        (let [fs (registry/get-field-schema tenant-schema k)]
          (loc/field-name k fs)))
    (sequential? k)
    (->> k
         (map (fn [ka]
                (attribute-label tenant-schema ka)))
         (string/join " - "))
    :else
    nil))

(defn short-label
  [tenant-schema k]
  (when (keyword? k)
    (let [fs (registry/get-field-schema tenant-schema k)]
      (some-> fs
              :field/short-name
              :en))))
